import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type", "value", "defaultValue", "name", "input", "onChange"];
import React from 'react';
// TODO: Replace with React's built-in `useId` once we upgrade to React 18+
import { useId } from '@radix-ui/react-id';
import { InputStyles } from "./Input.styles.js";
import { FormField } from "../FormField.js";
export var Input = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _props$id;
  var _props$type = props.type,
    type = _props$type === void 0 ? 'text' : _props$type,
    value = props.value,
    defaultValue = props.defaultValue,
    name = props.name,
    input = props.input,
    onChange = props.onChange,
    formProps = _objectWithoutProperties(props, _excluded);
  var hasError = props.hasError,
    disabled = props.disabled,
    readonly = props.readonly;
  var generatedId = useId();
  var fieldId = (_props$id = props.id) !== null && _props$id !== void 0 ? _props$id : generatedId;
  return /*#__PURE__*/React.createElement(FormField, _extends({
    ref: ref,
    formFieldType: "input"
  }, formProps, {
    id: fieldId
  }), /*#__PURE__*/React.createElement(InputStyles.Input, _extends({
    "data-testid": "input-input",
    "data-ds-input": true
  }, input, {
    id: fieldId,
    "aria-invalid": hasError,
    value: value,
    onChange: onChange,
    type: type,
    defaultValue: defaultValue,
    name: name,
    placeholder: "\xA0",
    disabled: disabled,
    readOnly: readonly
  })));
});